import type { Props } from './Svg'

export function PowerBigIcon(props: Props) {
  return (
    <svg width="80" height="79" fill="none" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M39.6 69.3a29.6 29.6 0 1 0 0-59.3 29.6 29.6 0 0 0 0 59.3Z"
      />
      <path
        fill="currentColor"
        d="M40 50a10 10 0 0 1-4.4-19 1 1 0 1 1 .8 1.9A8 8 0 0 0 32 40a8 8 0 1 0 11.6-7.2 1 1 0 0 1 .8-1.7A9.9 9.9 0 0 1 50 40a10 10 0 0 1-10 10Z"
      />
      <path fill="currentColor" d="M40 41a1 1 0 0 1-1-1v-9a1 1 0 1 1 2 0v9a1 1 0 0 1-1 1Z" />
    </svg>
  )
}
